export default __webpack_public_path__ + "static/media/aha-mainnav-footer-icon.a699de4a.svg";